import React from 'react';
import { IAdminWatchlist, adminShareWatchlist } from '../../api/admin';
import ShareResourceDialog from './ShareResourceDialog';

interface Props {
	open: boolean;
	onClose: () => void;
	watchlists: IAdminWatchlist[];
	sourceUserId: number;
}

export default function ShareWatchlistsDialog({ open, onClose, watchlists, sourceUserId }: Props) {
	async function handleShare(itemIds: number[], targetUserIds: number[], newNames: Record<number, string>, overwrite: boolean) {
		await Promise.all(
			itemIds.flatMap((id) => targetUserIds.map((uid) => adminShareWatchlist(id, uid, newNames[id], overwrite)))
		);
	}

	return (
		<ShareResourceDialog
			open={open}
			onClose={onClose}
			items={watchlists}
			resourceLabel="watchlist"
			sourceUserId={sourceUserId}
			onShare={handleShare}
		/>
	);
}
